import { render } from "./RatingBarRank11-1.vue?vue&type=template&id=a87b7ad4&scoped=true"
const script = {}

import "./RatingBarRank11-1.vue?vue&type=style&index=0&id=a87b7ad4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a87b7ad4"]])

export default __exports__